import { Avatar, Button, Grid, Box } from "@mui/material";
import _ from "lodash";
import React, { useState, useRef, useMemo } from "react";
import { useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import ReactToPrint from "react-to-print";
import { CandidateHeader } from "../Candidates/CandidateSimpleDetails";
import { CandidateEngagement } from "../Candidates/CandidateSimpleDetails/CandidateEngagement";
import { CandidateSummaryView } from "../Candidates/CandidateSimpleDetails/CandidateSummaryView";
import { OtherAssessments } from "../Candidates/CandidateSimpleDetails/OtherAssessments";

const Print = () => {
  const navigate = useNavigate();
  const componentRef = useRef(null);
  const [isOnPrintMode, setIsOnPrintMode] = useState(false);

  const {
    selectedCandidateData,
    missions,
    rewards,
    authRole,
    currentKeyWorker,
    portalUser,
  } = useSelector((state) => ({
    selectedCandidateData: state.candidates.selectedCandidateData,
    missions: state.portaldetails.missions,
    rewards: state.rewards,
    authRole: state.auth.role,
    currentKeyWorker: state.portaldetails.currentKeyWorker,
    portalUser: state.portaldetails.user,
  }));

  const sortedMissions = useMemo(() => {
    if (!missions || !selectedCandidateData?.latestAssessmentResult) {
      return [];
    }

    let newMissions = missions.map(item => {
      //GET SCORES
      const newItem = { ...item };

      newItem.score =
        selectedCandidateData.latestAssessmentResult.results[
          item.dimension
        ].percentage;

      //GET STATUS
      if (selectedCandidateData.missionsAnalytics) {
        selectedCandidateData.missionsAnalytics.forEach(mission => {
          if (mission.missionId === item.id) {
            if (
              newItem.status !== "Completed" &&
              mission.event_type === "missionStart"
            ) {
              newItem.status = "Started";
            }
            if (mission.event_type === "missionAssumedComplete") {
              newItem.status = "Completed";
            }
          }
        });
      }
      return newItem;
    });

    return _.sortBy(newMissions, ["score"]);
  }, [missions, selectedCandidateData]);

  if (!selectedCandidateData) {
    return <Navigate to="/portal/candidates" />;
  }

  return (
    <>
      <Button
        color="primary"
        variant="contained"
        onClick={() => navigate(-1)}
      >
        Back
      </Button>
      <ReactToPrint
        onBeforeGetContent={() =>
          new Promise((resolve) => {
            setIsOnPrintMode(true);
            setTimeout(() => {
              resolve();
            }, 500); // Reduced timeout
          })
        }
        onAfterPrint={() => setIsOnPrintMode(false)}
        content={() => componentRef.current}
        trigger={() => (
          <Button
            color="primary"
            variant="contained"
            style={{ margin: "1em" }}
          >
            Print
          </Button>
        )}
      />

      <Box sx={{ flexGrow: 1 }} ref={componentRef}>
        <Grid container direction="column">
          <Grid item size>
            <Avatar src={"/images/logo_gray.png"} className="show-on-print" />
          </Grid>
          <Grid item size>
            <CandidateHeader
              candidate={selectedCandidateData}
              user={selectedCandidateData}
            />
          </Grid>
          <Grid item size>
            <CandidateSummaryView
              isOnPrintMode={isOnPrintMode}
              candidate={selectedCandidateData}
              user={selectedCandidateData}
              groupSkillsBackpack
              rewards={rewards}
            />
          </Grid>
          <Grid item size>
            <CandidateEngagement
              missions={sortedMissions}
              candidate={selectedCandidateData}
              keyworkerId={
                authRole === "org-admin"
                  ? currentKeyWorker
                  : portalUser?.userID
              }
            />
          </Grid>
          <Grid item size>
            <OtherAssessments isOnPrintMode={isOnPrintMode} />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default Print;
